export default {
    /* eslint-disable no-console */
    none() {
        console.none(...arguments);
    },
    error() {
        console.error(...arguments);
    },
    warn() {
        console.warn(...arguments);
    },
    info() {
        console.info(...arguments);
    },
    debug() {
        console.log(...arguments);
    },
    trace() {
        console.trace(...arguments);
    },
    /* eslint-enable no-console */
};
